import { AnswerSelection, EditableQuestion } from '../../../../../types';

export const ONE_ANSWER_MESSAGE = 'An information screen shows one way past, so leave exactly one answer';
export const BLOCKING_ANSWER_MESSAGE =
  "An information screen's answer cannot be a blocking answer";

/**
 * A client that hides the selection shows a continue button; one that predates the field
 * draws the answers instead. Leave two and that older rendering offers a choice, which is
 * not an information screen; leave none and it has nothing to draw and no way past. The
 * api refuses the save as well, but the author needs to be told which answer to remove.
 */
export const validateAnswerSelection = (
  answerSelection: AnswerSelection | undefined,
  question: EditableQuestion,
  blockingAnswers: string[]
) => {
  if (answerSelection !== 'hidden') return true;

  if (question.answers?.length !== 1) return ONE_ANSWER_MESSAGE;

  // Only a client that still draws the answer can block on it, so a blocking flag here
  // stops some patients and not others depending on which app they are holding.
  return !blockingAnswers.includes(question.answers[0]._id) || BLOCKING_ANSWER_MESSAGE;
};
